import React from 'react';
import { Heart, Users, Award, Shield, Home, Sparkles } from 'lucide-react';
import '../styles/AboutUs.css';

const AboutUs = () => {
    const values = [
        {
            icon: Heart,
            title: "Compassionate Care",
            description: "Our dedicated staff provides personalized attention with warmth and respect, treating every resident like family."
        },
        {
            icon: Users,
            title: "Community First",
            description: "We foster meaningful connections and create opportunities for residents to engage, socialize, and thrive together."
        },
        {
            icon: Award,
            title: "Excellence",
            description: "We maintain the highest standards in senior care, continuously improving our services and facilities."
        },
        {
            icon: Shield,
            title: "Safety & Security",
            description: "24/7 professional care and monitoring ensure peace of mind for residents and their families."
        }
    ];

    const stats = [
        { number: "New", label: "Modern Facility" },
        { number: "24/7", label: "Professional Care" },
        { number: "50+", label: "Caring Staff Members" },
        { number: "100%", label: "Commitment to Excellence" }
    ];


    return (
        <section className="about-section">
            {/* Background Elements */}
            <div className="about-bg-gradient"></div>
            <div className="about-bg-pattern"></div>

            <div className="about-container">
                {/* Hero Section */}
                <div className="about-hero">
                    <span className="about-label">Our Story</span>
                    <h1>About Hollywood Royale Garden</h1>
                    <p className="about-subtitle">
                        Creating a warm, caring environment where seniors can live with dignity,
                        independence, and joy in the heart of Hollywood
                    </p>
                </div>

                {/* Story Section */}
                <div className="about-story">
                    <div className="story-content">
                        <div className="story-text">
                            <h2>The Premier Assisted Living in Hollywood</h2>
                            <p>
                                Hollywood Royale Garden is proud to introduce our first-ever assisted living community
                                in Los Angeles. Built with a vision to create a modern, caring home where seniors
                                can maintain their independence while receiving exceptional support, we're establishing
                                a new standard in compassionate senior care in Southern California.
                            </p>
                            <p>
                                Our brand-new assisted living community is designed to feel like home, with familiar spaces,
                                beautiful surroundings, and a dedicated staff who truly care. We believe that every
                                resident deserves to live with dignity, purpose, and joy, surrounded by people who
                                understand and support their unique needs.
                            </p>
                            <p>
                                Located in the vibrant Hollywood neighborhood, our residents enjoy access to
                                cultural attractions, beautiful weather, and a community that celebrates life at
                                every age. We're more than just a place to live – we're a family.
                            </p>
                        </div>
                        <div className="story-image">
                            <img
                                src="https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=800&h=600&fit=crop"
                                alt="Hollywood Royale Garden Community"
                            />
                            <div className="story-badge">
                                <Sparkles size={24} />
                                <span>Now Open</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Stats Section */}
                <div className="about-stats">
                    {stats.map((stat, index) => (
                        <div key={index} className="stat-card">
                            <h3>{stat.number}</h3>
                            <p>{stat.label}</p>
                        </div>
                    ))}
                </div>

                {/* Values Section */}
                <div className="about-values">
                    <div className="values-header">
                        <h2>Our Core Values</h2>
                        <p>The principles that guide everything we do</p>
                    </div>
                    <div className="values-grid">
                        {values.map((value, index) => (
                            <div key={index} className="value-card">
                                <div className="value-icon">
                                    <value.icon size={32} />
                                </div>
                                <h3>{value.title}</h3>
                                <p>{value.description}</p>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Mission & Vision */}
                <div className="mission-vision">
                    <div className="mission-card">
                        <div className="mission-icon">
                            <Home size={40} />
                        </div>
                        <h3>Our Mission</h3>
                        <p>
                            To provide exceptional assisted living services that promote independence,
                            dignity, and quality of life for our residents. We strive to create a warm,
                            supportive environment where seniors can thrive physically, emotionally, and socially.
                        </p>
                    </div>
                    <div className="vision-card">
                        <div className="vision-icon">
                            <Sparkles size={40} />
                        </div>
                        <h3>Our Vision</h3>
                        <p>
                            To be the premier assisted living community in Los Angeles, recognized for our
                            compassionate care, innovative programs, and commitment to enhancing the lives of
                            seniors and their families.
                        </p>
                    </div>
                </div>

                {/* CTA Section */}
                <div className="about-cta">
                    <div className="cta-content">
                        <h2>Experience the Hollywood Royale Garden Difference</h2>
                        <p>Schedule a tour and discover why families trust us with their loved ones</p>
                        <div className="cta-buttons">
                            <a href="/contact" className="cta-btn primary">
                                Schedule a Tour →
                            </a>
                            <a href="/contact" className="cta-btn secondary">
                                Contact Us →
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
